import { DeviceLevelNameDict, getDeviceTypeLevels } from "@/commons/enums/model-type";
import { BasicControl, CURSOR_TYPE, Listeners, Point, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { DeviceComponentT } from "../models/DeviceComponentT";
import { CableT } from "../models/CableT";
import { DEVICEBASE_SINGAL } from "../enums/devicebase-singal";
import { DEVICE_CTRL_TYPE } from "../enums/control-type";




export class UpdateCableEndControl extends BasicControl {
    id = DEVICE_CTRL_TYPE.UPDATE_CABLE_END;

    point_down: Point = new Point();
    point_move: Point = new Point();
    step: number = 1;
    cable: CableT;
    location: string;

    // // pline所在的平面
    // plinePlane: Plane = new Plane();
    // // pline 头部的辅助移动线段区域
    // helpLine: CableT;
    // // pline 确定的区域
    // pline: CableT;
    // loop: boolean = false; // 闭合
    // orthogonalPoint: Vector3;
    // capturePoint: Vector3;

    // dymodeChoose: string = null;
    // next: boolean = false; // 当前正在输入端点的属性值
    // vertexIdx: number = 0; // 当前顶点

    // // 绘制多段线命令, 因为画多段线的中途就需要创建，后续都是更新
    // addPlineCmd: AddPlineCommand;

    // currentLine: Line = new Line();
    // // currentArc: Arc = new Arc();
    // _startToCenter: Vector3 = new Vector3();
    // _startToEnd: Vector3 = new Vector3();
    // _tangentDir: Vector3 = new Vector3();
    // _tangentDir_UCS: Vector3 = new Vector3();
    // _aClockwise = false;
    // currentAttribute: PlineAttributes = {
    //     bulge: 0,
    //     startWidth: 0,
    //     endWidth: 0,
    // };
    // //默认绘制Line 
    // mode = 'L';

    // needInit: boolean;
    // globalCableId: number;
    // layerUuid: string;
    // // 第一个选中设备
    // firstDevice: ModelBase;
    // // 第二个选中设备
    // secondDevice: ModelBase;
    // // 输入的线宽
    // inputWidth: number

    // center: Point = new Point();
    // radius: number;

    // options = [
    //     { name: '连接至另一设备', key: 'C' },
    //     { name: '放弃', key: 'U' },
    // ]
    // polarPoint: Vector3;
    // helpRayLine: LineT;
    // normal: Vector3;
    // origin: Vector3;
    // axisX: Vector3;
    // axisY: Vector3;
    // axisZ: Vector3;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        /** 初始化 */
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        // this.normal = this.context.ucsContext.getAxisList().axisZ.clone();
        // this.origin = this.context.ucsContext.getAxisList().origin.clone();
        // this.axisX = this.context.ucsContext.getAxisList().axisX.clone();
        // this.axisY = this.context.ucsContext.getAxisList().axisY.clone();
        // this.axisZ = this.context.ucsContext.getAxisList().axisZ.clone();
        // this._tangentDir = this.context.ucsContext.getAxisList().axisX.clone();
        // editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        // editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        /** 注册一些信号 */
        // this.listeners.signals.needCapture.dispatch();
        // this.listeners.signals.emptySelectedEntities.dispatch();
        // this.listeners.signals.onPointCapture.add(this.onPointCapture);
        // this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        // this.listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        // this.listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        // this.listeners.signals.onZoomChanged.add(this.onZoomChanged);
        this.editor.clampControl.enabled = false
        // TODO
        this.listeners.getSignal(DEVICEBASE_SINGAL.onUpadteCableEnd).add(this.onUpadteCableEnd);
        // 第四步才禁止
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        // this.extraContext.dymodeContext.setMode(DYMODE_MODE.POINT);
        this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        this.point_move.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);

        /** 清空选择 */
        // this.editor.selectControl.resetSelectedEntities();
        /** 这里：提示选择1个设备图元 */
        this.listeners.signals.sendToDymodeTip.dispatch('选择另一个未连接的设备图元:');
        this.extraContext.stmodeContext.setStmode('选择另一个未连接的设备图元');
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.PICK);
        console.log('UpdateCableEndControl added')
    }

    // 二级控制器销毁
    dispose(): void {
        // if (this.pline?.viewObj && !!this.pline?.viewObj?.parent) {
        //     this.pline.viewObj.parent.remove(this.pline.viewObj);
        // }
        // this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        // this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        // this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        // this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        // this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        // this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        // this.listeners.signals.onZoomChanged.remove(this.onZoomChanged);
        this.listeners.getSignal(DEVICEBASE_SINGAL.onUpadteCableEnd).remove(this.onUpadteCableEnd);
        // this.listeners.signals.noNeedCapture.dispatch();
        // this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.orthogonalControl.enabled = false;
        this.editor.clampControl.enabled = true
        // let obj = this.helpLine?.viewObj;
        // if (obj && !!obj.parent) {
        //     obj.parent.remove(obj);
        // }
        console.log('AssembleCableControl removed')
    }

    onUpadteCableEnd = (cable: CableT, location: string) => {
        this.cable = cable;
        this.location = location;
        let initData = {
            cable: cable,
            location: location,
        }
        this.listeners.signals.setInitControlData.dispatch(initData);
    }


    /**
     * 就一步
     * 满足：
     * - 确认选择的图元是设备图元
     * - 选择的图元和传入图元不是一个图元
     * - 确认选择的图元等级和传入图元是同一等级
     * - 选择图元的connected为false
     * 即可修改。
     */
    step_1 = () => {
        let selected = this.editor.selectControl.getSelectedEntityList()?.filter(entity => !entity.lock);
        if (selected?.length !== 1) {
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog('能且仅能选中一个图元。请重新选择。');
            return;
        }
        let deviceEntity = selected[0];
        if (deviceEntity.uuid === this.cable.uuid) {
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog('不可选中当前连接的图元。请重新选择。');
            return;
        }
        let level = getDeviceTypeLevels(deviceEntity.type);
        if (level === -1) {
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog('需选中设备图元。请重新选择。');
            return;
        }
        let oldLevel = -1;
        if (this.location === 'start') {
            let oldDevice = this.editor.entityDict[this.cable.extraData.firstDeviceUuid];
            oldLevel = getDeviceTypeLevels(oldDevice.type);
        } else if (this.location === 'end') {
            let oldDevice = this.editor.entityDict[this.cable.extraData.secondDeviceUuid];
            oldLevel = getDeviceTypeLevels(oldDevice.type);
        }
        if (level !== oldLevel) {
            let deviceTypeName = DeviceLevelNameDict[oldLevel];
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog(`需选择${deviceTypeName}图元。请重新选择。`);
            return;
        }
        if ((deviceEntity as DeviceComponentT).connected) {
            this.editor.selectControl.resetSelectedEntities();
            this.extraContext.stmodeContext.pushLog(`该设备已连接。请重新选择。`);
            return;
        }
        this.editor.listeners.getSignal(DEVICEBASE_SINGAL.onUpadteCableEndFinish).dispatch(this.cable, this.location, level, deviceEntity);
        this.editor.listeners.signals.onOpeCommandControlEnd.dispatch();
    }

    // 按下回车的回调
    onKeyMouseConfirm = () => {
        if (this.step === 1) {
            this.step_1();
        }
    }

    // // 发送结束布置的信号，并结束二级控制器
    // onCreateFinish = () => {
    //     // 防止dispose重复创建
    //     this.step = 0;
    //     let clone = this.pline.clone();
    //     clone.extraData = {
    //         globalCableId: this.globalCableId,
    //         firstDeviceUuid: this.firstDevice.uuid,
    //         secondDeviceUuid: this.secondDevice.uuid,
    //     }
    //     // clone.extraData = {
    //     //     globalCableId: this.globalCableId,
    //     //     firstDevice: this.firstDevice,
    //     //     secondDevice: this.secondDevice,
    //     // }
    //     let par = {
    //         addPris: [clone],
    //         firstDevice: this.firstDevice,
    //         secondDevice: this.secondDevice,
    //     }
    //     this.editor.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleCableFinish).dispatch(par);
    //     this.listeners.signals.onOpeCommandControlEnd.dispatch();
    // }

    initControl(data: any): void {
        if (!!data) {
            this.onUpadteCableEnd(data.cable, data.location);
        }
    }
}